<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <back-button :returnUrl="returnUrl"></back-button>
          <!-- <b-col cols="4" lg="2" xl="1">
            <b-button class="btn btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
            </b-button>
          </b-col> -->
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button
              class="btn btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            </b-button>
          </b-col>
          <b-col cols="4" lg="3" xl="2" class="mb-5">
            <b-button variant="secondary"
              @click="actionAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.email.email_sender_add')}}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItemsEmailSender.length > 0"
              :items="listItemsEmailSender"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              fixed
              hover
              :selectable="listItemsEmailSender.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="onRowClicked"
              :key="refreshKey">
              <template #cell(SenderName)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdEmailSender)">
                  <i class="fa-regular fa-pencil"></i>
                </span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdEmailSender)">
                  <i class="fa-regular fa-trash"></i>
                </span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import backButton from "@/components/common/backButton.vue"

export default {
  name: "EmailSenderPage",
  components: {
    'back-button': backButton,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      SenderName: '',
      listItemsEmailSender: [],
      listTitle: "",
      refreshKey: false,
      returnUrl: '/alerts/',
      sortBy: 'SenderName'
    }
  },
  created() {
    this.listTitle = this.$i18n.t("common.email.email_sender_list")
    this.activateSpinner = true
    this.getEmailSender()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'SenderName',
        label: this.$t('common.email.email_sender_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'SenderEmail',
        label: this.$t('common.email.email_sender_email'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'SmtpServer',
        label: this.$t('common.email.email_sender_smtp_server'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'SmtpPort',
        label: this.$t('common.email.email_sender_smtp_port'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'SmtpUser',
        label: this.$t('common.email.email_sender_smtp_user'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'SmtpPassword',
        label: this.$t('common.email.email_sender_smtp_password'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, {url: '/email/emailSender/add/-1' })
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.email.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.email.emailSender.delete(params)
              .then(resp => {
                that.listItemsEmailSender = that.listItemsEmailSender.filter(item => item.IdEmailSender !== id)
                that.$f7.modal({
                  title: that.$t('common.email.email_sender_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: '/email/emailSender/-1' })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.email.email_sender_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/email/emailSender/edit/' + id })
    },
    getEmailSender () {
      let that = this
      let params = { SenderName: this.SenderName }
      this.$engine.email.emailSender.fetch(params).then((resp) => {
        let emailSenderList = {}

        emailSenderList = resp.data.EmailSender || []

        that.updateEmailSender(emailSenderList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getEmailSender()
    },
    onRowClicked (item) {
      loadPage(this, { url: '/email/emailSender/details/' + item[0].IdEmailSender })
    },
    updateEmailSender (emailSenderList) {
      this.listItemsEmailSender = emailSenderList
    }
  }
}
</script>
